import { useState } from "react"
import { TableCell } from "@/components/ui/table"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { PipeStatusBadge } from "@/components/projects/pipe-status-badge"
import { PipeStatusPopoverContent } from "@/components/projects/pipe-status-popup"
import { TagPopoverContent } from "@/components/projects/tag-popup"
import { Plus } from "lucide-react"
import type { Project, ProjectTag, PipeStatusRecord } from "@/types"

type Props = {
  project: Project
  availableTags: ProjectTag[]
  pipeStatuses: PipeStatusRecord[]
}

export function PipeStatusCell({ project, availableTags, pipeStatuses }: Props) {
  const ps = project.pipe_status
  const tags = project.project_tags || []
  const [pipeOpen, setPipeOpen] = useState(false)
  const [tagOpen, setTagOpen] = useState(false)

  return (
    <TableCell>
      <div className="flex flex-col gap-2">
        <Popover open={pipeOpen} onOpenChange={setPipeOpen}>
          <PopoverTrigger asChild>
            <button className="flex w-fit cursor-pointer items-center rounded transition-colors hover:bg-accent">
              {ps ? <PipeStatusBadge pipeStatus={ps} /> : <span className="px-1 py-0.5 text-sm">—</span>}
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-auto max-h-[var(--radix-popover-content-available-height)] overflow-y-auto p-2">
            <PipeStatusPopoverContent project={project} pipeStatuses={pipeStatuses} onSelect={() => setPipeOpen(false)} />
          </PopoverContent>
        </Popover>
        <div className="flex flex-wrap items-center gap-1">
          {tags.map((tag) => (
            <span
              key={tag.id}
              className="rounded-full border px-1.5 py-0 text-[10px] font-medium leading-4"
              style={{
                borderColor: tag.color,
                color: tag.color,
              }}
            >
              {tag.name}
            </span>
          ))}
          <Popover open={tagOpen} onOpenChange={setTagOpen}>
            <PopoverTrigger asChild>
              <button className="text-muted-foreground inline-flex size-5 cursor-pointer items-center justify-center rounded transition-colors hover:bg-accent hover:text-foreground">
                <Plus className="size-3" />
              </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="w-72 max-h-[var(--radix-popover-content-available-height)] overflow-y-auto p-0">
              <TagPopoverContent project={project} availableTags={availableTags} onClose={() => setTagOpen(false)} />
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </TableCell>
  )
}
